var $ = require('jquery');

(function() {
	'use strict';

	$('.js-modal').click(function(){
		console.log('Test modal');
	});
})();